import styled from '@emotion/styled'

export const FormHeader = styled.header`
  display: flex;
  align-items: center;
`

export const BillFormWrapper = styled.div``

export const BillLine = styled.li``

export const BillLineTitleWrapper = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
`

export const ItemWrapper = styled.div``

export const FormFieldset = styled.fieldset`
  margin: 0;
  padding: 0;
  border: none;

  &:disabled {
    opacity: 0.5;

    * {
      pointer-events: none !important;
    }
  }
`
